import React, { Component } from "react";
import GeneralBloc from "../../../bloc/general_bloc";
import "./successful_registration_screen.css";
import { Input, Button, Form, Row, Col, Typography } from "antd";
import { EditOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined, IdcardOutlined, CloseOutlined } from "@ant-design/icons";
import AppFieldError from "../../component/form/app_field_error/app_field_error";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import config from "../../../data/constant/config";
import UtilBloc from "../../../bloc/util_bloc";
import AuthBloc from "../../../bloc/auth_bloc";
import { Redirect, withRouter } from "react-router-dom";
import Labels from "../../constant/labels";
import LanguageBloc from "../../../bloc/language_bloc";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import AppDialog from "../../component/app_dialog/app_dialog";
import App_loading_dialog from "../../dialog/app_loading_dialog";
import BaseScreen from "../base/base_screen/base_screen";
const { Text } = Typography;

//LoginScreen
class SuccessfulRegistrationScreen extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);
    this.state = {
      client: Config.context,
      route: routeParams,
      loaded: false,
      loading: true,
      seconds_remain: 59,
      minutes_remain: 9,
      remain: null,
      type: props.match.params.type,
      action: props.match.params.action,
    };
  }

  stateType() {
    return this.state.type;
  }

  stateAction() {
    return this.state.action;
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    clearInterval(this.myIntervalErrorOtp);
  }

  // Render Loading Content
  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <App_loading_dialog isLoading={this.state.loading} />
      </div>
    );
  }


  remarkDependOnType() {
    if (this.stateType() == "completed") {
      return <div>
        <p style={{ fontWeight: 'bold' }}>
          Your registration has been completed.<br />
          You will receive an email notification when documents are ready for download.
        </p>
        <p style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
          Pendaftaran anda telah selesai.<br />
          Anda akan menerima emel notis apabila dokumen sedia untuk dimuat turun.
        </p>
      </div>
    }

    if (this.stateType() == "updated") {
      return <div>
        <p style={{ fontWeight: 'bold' }}>
          Your new registration information has been submitted.<br />
          You may proceed for your first-time registration once latest information has been updated.
        </p>
        <p style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
          Maklumat pendaftaran baharu anda telah diserahkan.<br />
          Anda boleh meneruskan pendaftaran kali pertama anda sebaik sahaja maklumat terkini telah dikemaskinikan.
        </p>
      </div>
    }
  }

  render() {
    return <BaseScreen>
      <div className="no-scroll">
        <div className="container mt-5">
          <div className="d-flex align-items-center justify-content-center mb-5">
            <img
              src={
                GeneralBloc.getAssetsContextPath() +
                `/assets/images/cuepacs_login_banner.png`
              }
              alt="myCUEPACSCare"
              className="img-fluid"
              style={{ height: "100px" }}
            />
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <div
              className="border rounded shadow bg-white"
              style={{
                position: 'relative',
                padding: '20px',
                textAlign: 'center',
                maxWidth: '500px',
                width: '100%',
              }}
            >
              {/* Close Button */}
              <CloseOutlined
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  fontSize: '20px',
                  cursor: 'pointer',
                  width: "16px"
                }}
                onClick={() => {
                  if (this.stateType() == "completed") {
                    window.location.href = `/${this.state.client}/${Config.routes.generic.documents_screen}`;
                  }

                  if (this.stateType() == "updated") {
                    sessionStorage.clear();
                    localStorage.clear();
                    window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
                  }
                }} // Replace with your close logic
              />

              {/* Icon Section */}
              <div className="mb-5">
                <img
                  src={
                    GeneralBloc.getAssetsContextPath() +
                    `/assets/icons/updated_successful.png`
                  }
                  alt="myCUEPACSCare"

                  style={{
                    height: "auto",
                    width: "100px"
                  }}
                />

              </div>

              {/* Text Content */}
              {
                this.remarkDependOnType()
              }
            </div>
          </div>

        </div>
      </div>
    </BaseScreen>

  }
}

export default withRouter(SuccessfulRegistrationScreen);
